import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OpenZitiConsoleLibModule } from 'ziti-console-lib';
import { UiLoaderModule } from '@netfoundry-ui/ui/loader';
import { ConflictDetailsComponent } from '@netfoundry-ui/shared/conflict-details';
import { ServicePoliciesExtensionComponent } from './service-policies-extension/service-policies-extension.component';
import { ServicePolicyFormExtensionComponent } from './service-policy-form-extension/service-policy-form-extension.component';
import { ServicePolicyConflictDetailsPageComponent } from './service-policy-conflict-details-page/service-policy-conflict-details-page.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        OpenZitiConsoleLibModule,
        MatDialogModule,
        MatTooltipModule,
        UiLoaderModule,
        ConflictDetailsComponent,
    ],
    declarations: [
        ServicePoliciesExtensionComponent,
        ServicePolicyFormExtensionComponent,
        ServicePolicyConflictDetailsPageComponent,
    ],
    exports: [
        ServicePoliciesExtensionComponent,
        ServicePolicyFormExtensionComponent,
        ServicePolicyConflictDetailsPageComponent,
    ],
})
export class PageServicePoliciesExtensionModule {
}
